import { useNavigate } from 'react-router-dom';
import { useSiteData } from '@/data/siteData';

export default function HeroSection() {
  const navigate = useNavigate();
  const { settings } = useSiteData();

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="accueil"
      className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center"
    >
      <div className="absolute inset-0 bg-black">
        <img
          src={settings.heroImage}
          alt="Parc de véhicules d'occasion Easy Car au Tampon, La Réunion"
          title="Easy Car - achat, vente et reprise de véhicules d'occasion"
          fetchPriority="high"
          loading="eager"
          decoding="async"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center pt-20 md:pt-24">
        <h1 className="text-white font-heading text-3xl md:text-5xl lg:text-6xl font-bold max-w-4xl mx-auto leading-tight">
          Votre prochaine voiture vous attend chez Easy Car
        </h1>
        <p className="text-white/80 text-base md:text-lg lg:text-xl max-w-2xl mx-auto mt-4 md:mt-6 leading-relaxed">
          Des véhicules d'occasion sélectionnés, révisés et accompagnés de services pensés pour rouler sereinement.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 mt-6 md:mt-8">
          <div className="flex items-center gap-2 text-white/90 text-sm md:text-base bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-star-fill w-4 h-4 flex items-center justify-center text-yellow-400" />
            <span>4,9/5 sur Google</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8 md:mt-10">
          <button
            onClick={() => navigate('/vehicules')}
            className="px-6 py-3 md:px-8 md:py-4 rounded-md bg-primary-500 text-white font-label font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            Voir tous nos véhicules
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-3 md:px-8 md:py-4 rounded-md border border-white/50 text-white font-label font-medium text-sm md:text-base hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            Nous contacter
          </button>
        </div>
      </div>
    </section>
  );
}
